import { useMemo } from 'react';
import { FilterButtons } from 'app/agriculture/infobox/common/FilterButtons/FilterButtons';
import { useDevices } from 'app/agriculture/queries/devices/useDevices';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';
import { Device } from 'app/agriculture/queries/devices/types/Device';

interface DeviceButtonFiltersProps {
    filterIds: string[];
    onFilterIdsChange: (filterIds: string[]) => void;
}

export function DeviceButtonFilters({ filterIds, onFilterIdsChange }: DeviceButtonFiltersProps) {
    const devices = useDevices();

    const devicesByType = useMemo(() => {
        const map = new Map<Device['deviceType'], Device[]>();
        for (const device of devices.values()) {
            map.set(device.deviceType, [...(map.get(device.deviceType) ?? []), device]);
        }
        return map;
    }, [devices]);

    const items = useMemo(
        () =>
            [...devicesByType.keys()].map((deviceType) => ({
                name: deviceType,
                id: deviceType,
                icon: <DeviceIcon deviceType={deviceType} size={18} />,
            })),
        [devicesByType],
    );

    return (
        <FilterButtons
            orderBy="alphabetical"
            showMoreLimit={3}
            items={items}
            filterIds={filterIds}
            onChange={onFilterIdsChange}
        />
    );
}
